export const STATUS = {
  IDLE: 'IDLE',
  PROCESSING: 'PROCESSING',
  RESOLVED: 'RESOLVED',
  REJECTED: 'REJECTED',
}
